/*
//import LinkOption from "./LinkService.vue";
import Ncf from "./NcfLinkService.vue";
import mpago from "./MagypagoLinkService.vue";
import fide from "./FidelizacionLinkService.vue";
import CustomerLink from "./CustomerLink.vue";
import TerminalLink from "./TerminalesLink.vue";
import CustomerACT from "./CustomerACT.vue";
import CustomerINA from "./CustomerINA.vue";
*/
//import hyperlinkNFC from "@/components/functionals/HyperlinkForNfcMovilReports.vue";
//import hyperlinkPP from "@/components/functionals/HyperlinkPagoProveedores.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";
//import ColorType from "@/components/functionals/ColorType.vue";

export const UpdateSupplierAccountColumns = [
  {
    prop: "ID",
    label: "Empresa ID",
    minWidth: 80,
    align: "center",
    sortable: true,
    fixed: true,
    formatter: (row) => row.EmpresaId
  },
  {
    prop: "ClienteId",
    label: "Cliente ID",
    minWidth: 110,
    fixed: true,
    align: "center",
    sortable: true,
    formatter: (row) => row.ClienteId
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "ncf",
    label: "NCF",
    minWidth: 120,
    sortable: true,
    formatter: (row) => row.ncf
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "fechaHora",
    label: "Fecha Hora",
    minWidth: 110,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: DatetimeFormatter
  },
  {
    prop: "Monto",
    label: "Total Credito",
    minWidth: 110,
    align: "center",
    sortable: true,
    formatter: (row) => formatMonto(row.Total_Credito)
  },
  {
    prop: "Descripcion",
    label: "Descripción",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.Concepto
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "TarjetaId",
    label: "Tarjeta Id",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.TarjetaId
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "Nombre_Tarjeta",
    label: "Nombre Tarjeta",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.Nombre_Tarjeta
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "Placa",
    label: "Placa",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.Placa
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "Vehiculo",
    label: "Vehiculo",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.Vehiculo
    //fixed: false
    //formatter: hyperlinkNFC
  }
];
